/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ReinclusaoBeneficiarioConsultaAliases {
  CONTEXTUAL_BAR_CONSULTA_REINCLUSAO_BENEF = 'contextual-bar-consulta-reinclusao-benef',
  DECK_0 = 'deck-0',
  FETCH_CONSULTA = 'fetch-consulta',
  FIELD_0 = 'field-0',
  FIELD_BENEFICIARIO = 'field-beneficiario',
  FIELD_DATA_SOLICITACAO = 'field-data-solicitacao',
  FIELD_PRODUTO = 'field-produto',
  FILTER_CONSULTA = 'filter-consulta',
  FILTERED_LIST_0 = 'filtered-list-0',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  LOCATOR_0 = 'locator-0',
  PANEL_CONSULTA_REINCLUSAO_BENEF = 'panel-consulta-reinclusao-benef',
  RENDER_STATUS = 'render-status',
  TEXT_BENEFICIARIO = 'text-beneficiario',
  TEXT_DATA_SOLICITACAO = 'text-data-solicitacao',
  TEXT_REPASSE = 'text-repasse',
}
export { ReinclusaoBeneficiarioConsultaAliases };
